import Tooltip from 'react-tooltip-lite';
import {
  MOBILE_TOOLTIP_DISTANCE,
  SHARED_TOOLTIP_DISTANCE,
} from '../../../constants/breakpoints';

import useIsMobile from '../../../hooks/useIsMobile';
import { useTranslation } from '../../../utils/i18n';

const ServiceTitle = ({
  number,
  notUnique = false,
  title,
}: {
  number: number;
  notUnique?: boolean;
  title: string;
}) => {
  const isMobileView = useIsMobile();
  const { t } = useTranslation('common');

  const titleWithNumber = () => {
    return `${number}. ${
      title === ''
        ? t('registration.service_details.container_title_new')
        : title
    }`;
  };

  return (
    <h4>
      {notUnique && (
        <Tooltip
          content={t('registration.service_details.services_not_unique')}
          className="header__not-unique-indicator"
          distance={
            isMobileView ? MOBILE_TOOLTIP_DISTANCE : SHARED_TOOLTIP_DISTANCE
          }
        >
          <i className="fas fa-exclamation-triangle" />
        </Tooltip>
      )}
      {titleWithNumber()}
    </h4>
  );
};

export default ServiceTitle;
